<template>
  <div class="container center-align">
    <main>
      <!-- Add two inputs for "phoneNumber" and "code" -->
      <!-- <input type="tel" id="phoneNumber" v-model="user.num" />
      <input type="text" id="code" v-model="user.code" />-->

      <!-- Add two buttons to submit the inputs -->
      <!-- <button id="sign-in-button" @click="submitPhoneNumberAuth">SIGN IN WITH PHONE</button>
      <button id="confirm-code" @click="submitPhoneNumberAuthCode">ENTER CODE</button>-->

      <!-- Add a container for reCaptcha -->
      <!-- <div id="recaptcha-container"></div> -->
      <div>
        <h1 class="h3 mb-3 font-weight-normal">About Me</h1>
        <h6>Please fill the following details, you will be notified through mobile number.</h6>
        <div class="alert alert-warning" v-if="errors.length">
          <b>Please correct the following error(s):</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <label for="name" class="sr-only">Name</label>
        <input
          type="text"
          id="name"
          class="form-control"
          placeholder="Name"
          :readonly="userAlreadyExists"
          autofocus
          v-model="$store.state.name"
        />
        <label for="insti" class="sr-only">Institute</label>
        <input
          type="text"
          id="insti"
          class="form-control"
          placeholder="Institute"
          :readonly="userAlreadyExists"
          v-model="$store.state.institute"
        />
        <label for="phno" class="sr-only">phno</label>
        <input
          type="tel"
          id="phno"
          class="form-control"
          placeholder="Phone Number"
          :readonly="userAlreadyExists"
          v-model="$store.state.phno"
        />
        <label for="email" class="sr-only">email</label>
        <input
          type="tel"
          id="email"
          class="form-control"
          placeholder="Email"
          :readonly="userAlreadyExists"
          v-model="$store.state.email"
        />
        <label for="city" class="sr-only">City/Town</label>
        <input
          type="text"
          id="city"
          class="form-control"
          :readonly="userAlreadyExists"
          placeholder="City/Town"
          v-model="$store.state.city"
        />
        <button
          id="nextPage"
          class="btn mt-4 btn-block waves-effect orange lighten-3 btn black-text waves-dark"
          @click="goNext"
          v-show="!userAlreadyExists"
        >Start Quiz</button>
        <button
          id="nextPage"
          class="mt-4 btn btn-block waves-effect orange lighten-3 btn black-text waves-dark"
          @click="$router.push({name:'viewVideos'})"
           v-show="userAlreadyExists"
        >Start Quiz</button>
      </div>
    </main>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  data() {
    return {
      errors: [],
      check: null,
      userAlreadyExists: false,
    };
  },
  methods: {
    goNext() {
      if (this.checkForm()) {
        firebase
          .database()
          .ref()
          .child("UserDetails")
          .child(this.$store.state.phno)
          .on("value", (data) => {
            this.check = data.val();
            console.log(data.val());
            console.log(this.check);
            if (this.check == null) {
               console.log("new user");
               console.log(this.check);
              firebase
                .database()
                .ref()
                .child("UserDetails")
                .child(this.$store.state.phno)
                .set({
                  ["Name"]: this.$store.state.name,
                  ["Email"]: this.$store.state.email,
                  ["Phone Number"]: this.$store.state.phno,
                  ["City"]: this.$store.state.city,
                  ["Institute"]: this.$store.state.institute
                });
              console.log("Ye");
               this.$router.push({ name: "viewVideos" });
            }
            else{
              this.errors.push( "User already in database, click submit to proceed.")
              console.log("user exists :"+this.check);
              this.$store.state.name = this.check["Name"]
              this.$store.state.phno = this.check["Phone Number"]
              this.$store.state.email = this.check["Email"]
              this.$store.state.institute = this.check["Institute"]
              this.$store.state.city = this.check["City"]
              this.userAlreadyExists = true
            }
          });
      } else {
        console.log("Nay");
      }
    },
    checkForm(e) {
      this.errors = [];

      if (!this.$store.state.name) {
        this.errors.push("Name required.");
      }
      if (!this.$store.state.city) {
        this.errors.push("City required.");
      }
      if (this.$store.state.phno.length < 10) {
        this.errors.push("Phone number required.");
      }
      if (!this.$store.state.institute) {
        this.errors.push("Institute required.");
      }
      else if(this.$store.state.institute.length > 30){
         this.errors.push("Institute name should have max 30 chars.");
      }
      if(!this.$store.state.email){
        this.errors.push("Email required");
      }
      else if(!this.validEmail(this.$store.state.email)){
        this.errors.push('Valid email required.');
      }
      if (!this.errors.length) {
        return true;
      }
      console.log("this.$store.state");
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.$store.state.email);
    },
  },

};
</script>

<style>
</style>